module.exports = __webpack_public_path__ + "static/media/mgm_hero.5262f83a.jpg";